module.exports = __webpack_public_path__ + "img/gente_resolve_azul_2.f8fb4e89.png";